<h3>Abrechnung</h3>

<DataGridView [DataUrl]="dataurl()" #Grid KeyProperty="key">
  <DataGridViewColumn field="key" header="Lauf" [DataType]="Types.Number" />
  <DataGridViewColumn field="koopName" header="Partner" [DataType]="Types.String" />
  <DataGridViewColumn field="genertedvalue" header="Umsatz" [DataType]="Types.Number" formart="EUR" [pipe]="currencyPipe" />
  <DataGridViewColumn field="generatedEntryCount" header="Anzahl" [DataType]="Types.Number" />
  <DataGridViewColumn field="resubmitEntryCount" header="Anzahl (Resubmitted)" [DataType]="Types.Number" />
  <DataGridViewColumn field="createdAt" header="Erstellt Am" [DataType]="Types.Date" formart="dd.MM.yyyy"  />
  <DataGridViewColumn [AllowOrder]="false" [AllowSearch]="false" header="Inbetriebnahmen Vorhanden">
    <ng-template #cell let-row>
      <div class="form-check">
      <input type="checkbox" class="form-check-input" readonly disabled [checked]="row.missingInbts.length == 0" />
      @if(row.missingInbts.length > 0){
        <i class="form-check-label" style="cursor: pointer; text-decoration: underline; color: #0a53be;opacity: 1;" (click)="OpenAkten(row.missingInbts)">Liste</i>
      }
      </div>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn [AllowOrder]="false" [AllowSearch]="false" header="Gesendet / Exported">
    <ng-template #cell let-row>
      <div class="form-check">
        <input type="checkbox" class="form-check-input" readonly disabled [checked]="row.gesendet" />
      </div>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn [isFixed]="true" [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <a class="btn btn-sm btn-primary bi bi-pencil-fill" href="/Absetzung/{{row.koopId}}/{{row.key}}" ></a>
      <button class="btn btn-sm btn-primary bi bi-database-fill-down ms-1" [disabled]="row.missingInbts.length > 0" (click)="download(row)"></button>
      @if(row.canUpload){
        <button class="btn btn-sm btn-primary bi bi-cloud-upload-fill ms-1" [disabled]="row.missingInbts.length > 0" (click)="upload(row)"></button>
      }
    </ng-template>
    <ng-template #header>

    </ng-template>
  </DataGridViewColumn>

</DataGridView>

<floatingButton icon="bi bi-plus" title="Abrechnung Anlegen" (btnClick)="CreateNewInvoice()"></floatingButton>
